var RefreshSongsEventMixin = {
	methods: {
		refreshSongs() {
			// implement in child component
		}
	},
	mounted() {
		document.addEventListener("RefreshSongs", this.refreshSongs);
	},
	destroyed() {
		document.removeEventListener("RefreshSongs", this.refreshSongs);
	}
};


export { RefreshSongsEventMixin };
